import { AxiosError } from 'axios';

interface ApiErrorResponse {
  error?: string;
  message?: string;
}

/**
 * Extracts error message from various error types
 * @param error - Error object (AxiosError, Error, or unknown)
 * @param defaultMessage - Fallback message if no specific error is found
 * @returns Error message string
 */
export function getErrorMessage(error: unknown, defaultMessage: string): string {
  if (error instanceof AxiosError) {
    const responseData = error.response?.data as ApiErrorResponse | undefined;
    return responseData?.error || responseData?.message || defaultMessage;
  }

  if (error instanceof Error) {
    return error.message || defaultMessage;
  }

  return defaultMessage;
}
